import React, { useRef, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const InactivityHandler = ({
  timeout = 20 * 60 * 1000, // 20 minutes
  promptDuration = 60 * 1000, // 1 minute before auto logout
  onLogout,
}) => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [remaining, setRemaining] = useState(promptDuration / 1000);
  const countdownRef = useRef(null); // ref to store interval

  // Called when user becomes idle (no activity for timeout ms)
  const onIdle = () => {
    setShowModal(true);
    startPromptTimer();
  };

  // Called when user becomes active again
  const onActive = () => {
    // resetPrompt();
  };

  const { reset } = useIdleTimer({
    timeout,
    onIdle,
    onActive,
    debounce: 500,
    crossTab: false, // handles multi-tab sessions
  });


  // Start countdown before auto logout
  const startPromptTimer = () => {
    let time = promptDuration / 1000;
    setRemaining(time);

    if (countdownRef.current) clearInterval(countdownRef.current);

    countdownRef.current = setInterval(() => {
      time -= 1;
      setRemaining(time);
      if (time <= 0) {
        clearInterval(countdownRef.current);
        handleLogout();
      }
    }, 1000);
  };

  // Reset timer when user chooses to continue
  const resetPrompt = () => {
    if (countdownRef.current) clearInterval(countdownRef.current);
    setShowModal(false);
    setRemaining(promptDuration / 1000);
    reset(); // resets the idle timer
  };

  // Logout user
  const handleLogout = () => {
    if (countdownRef.current) clearInterval(countdownRef.current);
    setShowModal(false);
    if (onLogout) onLogout();
    navigate("/login", { replace: true });
  };

  return (
    <Modal show={showModal} backdrop="static" centered keyboard={false}>
      <Modal.Header>
        <Modal.Title> Timeout Warning!!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <p>You have been inactive for 20 minutes.</p> */}
        <p>
          You will be automatically logged out in <strong>{remaining}</strong>{" "}
          seconds.
        </p>
        <p>Do you want to Continue?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={resetPrompt}>
          Yes
        </Button>
        <Button variant="danger" onClick={handleLogout}>
          No
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InactivityHandler;
